// Enum configuration system for BonCap vs Standard plans
// BonCap uses values from docs/ folder, other plans use standard values

// STANDARD ENUMS (for non-BonCap plans)
const STANDARD_ENUMS = {
  maritalStatuses: [
    { value: "", label: "" },
    { value: "S", label: "SINGLE" },
    { value: "M", label: "MARRIED" },
    { value: "D", label: "DIVORCED" },
    { value: "W", label: "WIDOWED" },
    { value: "C", label: "COHABITING" }
  ],
  
  languages: [
    { value: "", label: "" },
    { value: "AFR", label: "Afrikaans" },
    { value: "ENG", label: "English" },
    { value: "ZUL", label: "Zulu" },
    { value: "XHO", label: "Xhosa" },
    { value: "NDA", label: "Ndebele" },
    { value: "SWA", label: "Swazi (Siswati)" },
    { value: "NSO", label: "Northern Sotho (Sepedi)" },
    { value: "SSO", label: "Southern Sotho (Sesotho)" },
    { value: "TSW", label: "Tswana" },
    { value: "TSO", label: "Shangaan (Tsonga)" },
    { value: "FOR", label: "Foreign" },
    { value: "VEN", label: "Venda" },
    { value: "UNK", label: "Unknown" }
  ],
  
  ethnicities: [
    { value: "", label: "" },
    { value: "A", label: "Asian" },
    { value: "B", label: "Black" },
    { value: "I", label: "Indian" },
    { value: "W", label: "White" },
    { value: "C", label: "Coloured" },
    { value: "O", label: "Other" }
  ],
  
  relationshipOptions: [
    { value: "", label: "" },
    { value: "SPO", label: "Spouse" },
    { value: "DSPO", label: "Divorced Spouse" },
    { value: "CLSPO", label: "Common Law Spouse (Life partner/boyfriend/girlfriend)" },
    { value: "PAR", label: "Parent (own parents)" },
    { value: "OTHER", label: "In laws (Father & Mother)" },
    { value: "CHI", label: "Child & Stepchild" },
    { value: "CHISTU", label: "Student" },
    { value: "FCHI", label: "Foster child (legal documentation required)" },
    { value: "CHIADO", label: "Legally adopted child" },
    { value: "DCHI", label: "Disabled dependants over 21 (if approved by Fund Manager)" },
    { value: "DCHIC", label: "Disabled Child" },
    { value: "OCHI", label: "Overage Child" },
    { value: "GCHI", label: "Grandchild" },
    { value: "SIBC", label: "Sibling (Child)" },
    { value: "SIBA", label: "Sibling (Adult)" },
    { value: "OTHERA", label: "Other Dependent Relative (Adult)" },
    { value: "OTHERC", label: "Other Dependent Relative (Child)" }
  ],
  
  accountTypes: [
    { value: '', label: '' },
    { value: 'Savings', label: 'Savings' },
    { value: 'Current', label: 'Cheque / Current' },
    { value: 'Transmission', label: 'Transmission' },
    { value: 'Bond', label: 'Bond' }
  ],
  
  bankOptions: [
    { label: 'ABSA BANK', value: 'ABSA', code: '632005', api: 'ABSA', branchname: 'Absa' },
    { label: 'AFRICAN BANK', value: 'AFRICAN', code: '430000', api: 'AFRICAN', branchname: 'African Bank' },
    { label: 'BIDVEST BANK', value: 'BIDVEST', code: '462005', api: 'BIDVEST', branchname: 'Bidvest' },
    { label: 'CAPITEC BANK', value: 'MEEG', code: '470010', api: 'MEEG', branchname: 'Capitec' },
    { label: 'DISCOVERY BANK', value: 'DISC_BANK', code: '679000', api: 'DISC_BANK', branchname: 'Discovery' },
    { label: 'FNB', value: 'FNB', code: '250655', api: 'FNB', branchname: 'FNB' },
    { label: 'INVESTEC', value: 'INVESTEC', code: '580105', api: 'INVESTEC', branchname: 'Investec' },
    { label: 'NEDBANK', value: 'NEDCOR', code: '198765', api: 'NEDCOR', branchname: 'Nedbank' },
    { label: 'OLD MUTUAL', value: 'BIDVEST', code: '462005', api: 'BIDVEST', branchname: 'Old Mutual' },
    { label: 'STANDARD BANK', value: 'STANDARD', code: '051001', api: 'STANDARD', branchname: 'Standard' },
    { label: 'TYME BANK', value: 'TYMDG_BANK', code: '678910', api: 'TYMDG_BANK', branchname: 'Tyme' },
    { label: 'BANK ZERO', value: 'BANK Z', code: '888000', api: 'BANK Z', branchname: 'Bank Zero' },
    { label: 'SASFIN BANK', value: 'SASFIN_BANK', code: '683000', api: 'SASFIN_BANK', branchname: 'Sasfin' }
  ]
};

// BONCAP ENUMS (from docs/ folder)
const BONCAP_ENUMS = {
  maritalStatuses: [
    { value: "", label: "" },
    { value: "M", label: "Married" },
    { value: "S", label: "Single" },
    { value: "D", label: "Divorced" },
    { value: "W", label: "Widow" },
    { value: "C", label: "Cohabiting" }
  ],
  
  languages: [
    { value: "", label: "" },
    { value: "AFR", label: "Afrikaans" },
    { value: "ENG", label: "English" },
    { value: "ZUL", label: "isiZulu" },
    { value: "XHO", label: "isiXhosa" },
    { value: "NDA", label: "isiNdebele" },
    { value: "SWA", label: "Swazi (Siswati)" },
    { value: "NSO", label: "Northern Sotho (Sepedi)" },
    { value: "SSO", label: "Southern Sotho (Sesotho)" },
    { value: "TSW", label: "Setswana" },
    { value: "TSO", label: "Xitsonga" },
    { value: "FOR", label: "Foreign" },
    { value: "VEN", label: "Tshivenda" },
    { value: "UNK", label: "Unknown" },
    { value: "SAS", label: "South African Sign" }
  ],
  
  ethnicities: [
    { value: "", label: "" },
    { value: "B", label: "Black" },
    { value: "W", label: "White" },
    { value: "C", label: "Coloured" },
    { value: "A", label: "Asian" },
    { value: "U", label: "Unknown" }
  ],
  
  relationshipOptions: [
    { value: "", label: "" },
    { value: "SELF", label: "Self" },
    { value: "SPO", label: "Spouse" },
    { value: "DSPO", label: "Divorced Spouse" },
    { value: "CLSPO", label: "Common Law Spouse" },
    { value: "PAR", label: "Parents" },
    { value: "OTHER", label: "Other Relative" },
    { value: "FCHI", label: "Foster Child" },
    { value: "OCHI", label: "Overaged child" },
    { value: "CHI", label: "Child / Stepchild" },
    { value: "DCHI", label: "Disabled Dependent of Any Age" },
    { value: "GCHI", label: "Grandchild" },
    { value: "STU", label: "Student" },
    { value: "SIB", label: "Sibling" },
    { value: "ACHI", label: "Adopted Child" },
    { value: "UNK", label: "Unknown" }
  ],
  
  accountTypes: [
    { value: '', label: '' },
    { value: 'CA', label: 'Cheque Account or Current Account' },
    { value: 'SA', label: 'Savings Account' },
    { value: 'TA', label: 'Transmission Account' },
    { value: 'BA', label: 'Bond Account' },
    { value: 'SSA', label: 'Subscription Share account' }
  ],
  
  bankOptions: [
    { label: 'NONE', value: '', code: '', api: '', branchname: '' },
    { label: 'ALBARAKA BANK', value: 'AB', code: '', api: 'AB', branchname: 'Albaraka Bank' },
    { label: 'ABSA OF LESOTHO', value: 'ABL', code: '', api: 'ABL', branchname: 'Absa of Lesotho' },
    { label: 'ABSA PRIVATE BANK', value: 'ABPB', code: '', api: 'ABPB', branchname: 'Absa Private Bank' },
    { label: 'ABSA', value: 'ABSA', code: '632005', api: 'ABSA', branchname: 'Absa' },
    { label: 'AFRICAN BANK', value: 'AFB', code: '430000', api: 'AFB', branchname: 'African Bank' },
    { label: 'ALLIED BANK', value: 'ALB', code: '', api: 'ALB', branchname: 'Allied Bank' },
    { label: 'BARCLAYS BANK BOTSWANA', value: 'BBBW', code: '', api: 'BBBW', branchname: 'Barclays Bank Botswana' },
    { label: 'BANK BIC NAMIBIA LIMITED', value: 'BBNL', code: '', api: 'BBNL', branchname: 'Bank BIC Namibia Limited' },
    { label: 'BIDVEST BANK', value: 'BID', code: '462005', api: 'BID', branchname: 'Bidvest' },
    { label: 'BANK OF NAMIBIA', value: 'BNAM', code: '', api: 'BNAM', branchname: 'Bank of Namibia' },
    { label: 'Bank Zero', value: 'BNKZ', code: '888000', api: 'BNKZ', branchname: 'Bank Zero' },
    { label: 'BANK OF ATHENS', value: 'BOA', code: '', api: 'BOA', branchname: 'Bank of Athens' },
    { label: 'BoE BANK LIMITED', value: 'BOE', code: '', api: 'BOE', branchname: 'BoE Bank Limited' },
    { label: 'BOLAND PKS', value: 'BOLB', code: '', api: 'BOLB', branchname: 'Boland PKS' },
    { label: 'BANK OF TRANSKEI', value: 'BOT', code: '', api: 'BOT', branchname: 'Bank of Transkei' },
    { label: 'BANK WINDHOEK', value: 'BW', code: '', api: 'BW', branchname: 'Bank Windhoek' },
    { label: 'CAPITEC', value: 'CAP', code: '470010', api: 'CAP', branchname: 'Capitec' },
    { label: 'COMMERCIAL BANK OF NAMIBIA', value: 'CBN', code: '', api: 'CBN', branchname: 'Commercial Bank of Namibia' },
    { label: 'CAPE OF GOOD HOPE BANK', value: 'CGHB', code: '', api: 'CGHB', branchname: 'Cape of Good Hope Bank' },
    { label: 'CITIBANK N.A SOUTH AFRICA', value: 'CITI', code: '', api: 'CITI', branchname: 'Citibank N.A South Africa' },
    { label: 'DISCOVERY BANK', value: 'DISC', code: '679000', api: 'DISC', branchname: 'Discovery' },
    { label: 'FIRST NATIONAL BANK', value: 'FNB', code: '250655', api: 'FNB', branchname: 'FNB' },
    { label: 'FIRST NATIONAL BANK NAMIBIA', value: 'FNBN', code: '', api: 'FNBN', branchname: 'First National Bank Namibia' },
    { label: 'GO BANKING', value: 'GOB', code: '', api: 'GOB', branchname: 'Go Banking' },
    { label: 'GroBank', value: 'GROB', code: '', api: 'GROB', branchname: 'GroBank' },
    { label: 'Henry Ansbacher Private Banking Services', value: 'HAPB', code: '', api: 'HAPB', branchname: 'Henry Ansbacher Private Banking Services' },
    { label: 'HABIB BANK OF ZURICH', value: 'HBZ', code: '', api: 'HBZ', branchname: 'Habib Bank of Zurich' },
    { label: 'HABIB OVERSEAS BANK', value: 'HOB', code: '', api: 'HOB', branchname: 'Habib Overseas Bank' },
    { label: 'HSBC', value: 'HSBC', code: '', api: 'HSBC', branchname: 'HSBC' },
    { label: 'Investec Private Bank', value: 'IPB', code: '580105', api: 'IPB', branchname: 'Investec' },
    { label: 'ITHALA', value: 'ITH', code: '', api: 'ITH', branchname: 'Ithala' },
    { label: 'Lesotho Postbank', value: 'LPBK', code: '', api: 'LPBK', branchname: 'Lesotho Postbank' },
    { label: 'MediCoop CFI', value: 'MEDI', code: '', api: 'MEDI', branchname: 'MediCoop CFI' },
    { label: 'MEEG BANK', value: 'MEEG', code: '470010', api: 'MEEG', branchname: 'Capitec' },
    { label: 'CAPITEC BUSINESS (Formerly Mercantile)', value: 'MERC', code: '', api: 'MERC', branchname: 'Capitec Business' },
    { label: 'MERCANTILE LISBON BANK', value: 'MLB', code: '', api: 'MLB', branchname: 'Mercantile Lisbon Bank' },
    { label: 'NATAL BUILDING SOCIETY', value: 'NBS', code: '', api: 'NBS', branchname: 'Natal Building Society' },
    { label: 'NEDBANK SWAZILAND', value: 'NBSW', code: '', api: 'NBSW', branchname: 'Nedbank Swaziland' },
    { label: 'NEDBANK', value: 'NED', code: '198765', api: 'NED', branchname: 'Nedbank' },
    { label: 'NEDBANK OF LESOTHO', value: 'NEDL', code: '', api: 'NEDL', branchname: 'Nedbank of Lesotho' },
    { label: 'NEDBANK OF NAMIBIA', value: 'NEDN', code: '', api: 'NEDN', branchname: 'Nedbank of Namibia' },
    { label: 'OLD MUTUAL BANK', value: 'OMB', code: '462005', api: 'OMB', branchname: 'Old Mutual' },
    { label: 'PEOPLE\'S BANK', value: 'PBNK', code: '', api: 'PBNK', branchname: 'People\'s Bank' },
    { label: 'PERMANENT BANK', value: 'PERM', code: '', api: 'PERM', branchname: 'Permanent Bank' },
    { label: 'POST BANK', value: 'POST', code: '', api: 'POST', branchname: 'Post Bank' },
    { label: 'Pick N Pay Financial Services', value: 'PPFS', code: '', api: 'PPFS', branchname: 'Pick N Pay Financial Services' },
    { label: 'RAND MERCHANT BANK', value: 'RAND', code: '', api: 'RAND', branchname: 'Rand Merchant Bank' },
    { label: 'RMB PRIVATE BANK', value: 'RMB', code: '', api: 'RMB', branchname: 'RMB Private Bank' },
    { label: 'SASFIN BANK', value: 'SASF', code: '683000', api: 'SASF', branchname: 'Sasfin' },
    { label: 'STANDARD BANK OF LESOTHO', value: 'SBL', code: '', api: 'SBL', branchname: 'Standard Bank of Lesotho' },
    { label: 'STANDARD BANK OF NAMIBIA', value: 'SBN', code: '', api: 'SBN', branchname: 'Standard Bank of Namibia' },
    { label: 'STATE BANK OF INDIA', value: 'SBOI', code: '', api: 'SBOI', branchname: 'State Bank of India' },
    { label: 'SAAMBOU', value: 'SBOU', code: '', api: 'SBOU', branchname: 'Saambou' },
    { label: 'STANDARD BANK', value: 'SBSA', code: '051001', api: 'SBSA', branchname: 'Standard' },
    { label: 'STANDARD BANK OF SWAZILAND', value: 'SBSW', code: '', api: 'SBSW', branchname: 'Standard Bank of Swaziland' },
    { label: 'STANDARD CHARTERED BANK', value: 'SCB', code: '', api: 'SCB', branchname: 'Standard Chartered Bank' },
    { label: 'SME BANK LIMITED', value: 'SME', code: '', api: 'SME', branchname: 'SME Bank Limited' },
    { label: 'TRUST BANK', value: 'TB', code: '', api: 'TB', branchname: 'Trust Bank' },
    { label: 'Tyme Bank', value: 'TYME', code: '678910', api: 'TYME', branchname: 'Tyme' },
    { label: 'UNITED BANK', value: 'UNB', code: '', api: 'UNB', branchname: 'United Bank' },
    { label: 'VBS MUTUAL BANK', value: 'VBS', code: '', api: 'VBS', branchname: 'VBS Mutual Bank' },
    { label: 'VOLKSKAS', value: 'VKAS', code: '', api: 'VKAS', branchname: 'Volkskas' },
    { label: 'GRINDROD BANK', value: 'GRDB', code: '', api: 'GRDB', branchname: 'Grindrod Bank' },
    { label: 'UNKNOWN', value: 'UNK', code: '', api: 'UNK', branchname: 'Unknown' }
  ]
};

/**
 * Get appropriate enums based on plan type
 * @param {string} planType - The selected plan (e.g., 'PL470' for BonCap)
 * @returns {object} Object containing all enum arrays for the specified plan
 */
export function getEnums(planType) {
  const isBonCap = planType === 'PL470';
  return isBonCap ? BONCAP_ENUMS : STANDARD_ENUMS;
}

/**
 * Get titles (same for all plans)
 */
export const titles = ["", "MR", "MRS", "MS", "MISS", "DR", "PROF"];

/**
 * Get ID types (same for all plans)
 */
export const idTypes = ["", "ID Document", "Passport"];

